/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [categories, setCategories] = useState([])


  const getAppTypes = async () => {
    const { response } = await AppService.changelogs.get({
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getCategory = async () => {
    const { response } = await AppService.AppsChecklist.get_app_name({
      toaster: false,
    })
    if (response) {
      setCategories(response.data)
    } else {
      setCategories([])
    }
    setLoader(false)
  }


  const onLoad = () => {
    getAppTypes()
    getCategory()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.changelogs.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])
  const truncateText = (text, wordLimit = 8) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
  };

  return {
    loader: loader,
    categories: categories,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Description', accessor: 'description' },
        { Header: 'date', accessor: 'date' },
        { Header: 'feature', accessor: 'feature' },
        { Header: 'public', accessor: 'public' },
        { Header: 'type', accessor: 'type' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data.name ? `${data.name.substring(0, 15)}...` : "",
        description: data.description ? `${data.description.replace(/<[^>]+>/g, "").substring(0, 40)}...` : "",
        date: data.date,
        feature: data.feature ? `${data.feature.substring(0, 20)}...` : "",
        public: data.public ? "Yes" : "No",
        type: data.type,





        action: (
          <MDBox>
            <EditModal categories={categories} data={data} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
